/* eslint-disable no-multi-spaces */
import baseTheme from './baseTheme'

export default {
  ...baseTheme,
}
